import { render, staticRenderFns } from "./Section1.vue?vue&type=template&id=a9982e30&scoped=true&"
import script from "./Section1.vue?vue&type=script&lang=js&"
export * from "./Section1.vue?vue&type=script&lang=js&"
import style0 from "./Section1.vue?vue&type=style&index=0&id=a9982e30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9982e30",
  null
  
)

export default component.exports